import React from "react";
import { ModalSelect } from "../../../components/inputs/main";
import { ToolsKPIsData } from "../../../components/partials/box";

interface ToolCategoryStepProps {
  tools: any[];
  selection: any;
  formInfo: any[];
  handleKpi: (
    event: React.ChangeEvent<HTMLInputElement>,
    formIndex: number,
    kpiIndex: number
  ) => void;
  setModal: (modal: string) => void;
  setInfo: (info: any) => void;
  others?: any;
}

const ToolCategoryStep: React.FC<ToolCategoryStepProps> = ({
  tools,
  selection,
  formInfo,
  handleKpi,
  setModal,
  setInfo,
  others,
}) => {
  // Desired display order for tool categories in Step 2
  const categoryOrder = [
    "TOOL TYPE",
    "TOOL PURPOSE",
    "APPLICATION LEVEL",
    "TOOL AREA OF USE",
    "SECTOR",
    "REGION",
    "COUNTRY",
    "COST MODEL",
    "TYPE OF DATA COLLECTED",
  ];

  const sortedTools = [...(tools || [])].sort((a, b) => {
    const aCat = a?.category?.toString() || "";
    const bCat = b?.category?.toString() || "";
    const aIndex = categoryOrder.indexOf(aCat);
    const bIndex = categoryOrder.indexOf(bCat);

    if (aIndex === -1 && bIndex === -1) return 0;
    if (aIndex === -1) return 1;
    if (bIndex === -1) return -1;
    return aIndex - bIndex;
  });

  return (
    <div className="space-y-8 bg-white w-full p-8">
      <div className="h-full lg:w-2/3 pb-3 border-b">
        <h1 className="text-2xl font-semibold text-da-blue-600 inter">
          Tool Category
        </h1>
      </div>
      <div className="space-y-6 lg:w-2/3">
        <div className="grid grid-cols-2 gap-6">
          {sortedTools?.map((tool: any, i: number) => {
            // Customize labels here - you can create a mapping or transform the label
            const getLabel = (category: string) => {
              // Example: Custom label mapping
              const labelMap: { [key: string]: string } = {
                "TOOL TYPE": "Tool Type",
                "TOOL PURPOSE": "Tool Purpose",
                "APPLICATION LEVEL": "Application Level",
                "TOOL AREA OF USE": "Tool Area of Use",
                SECTOR: "Sub-Sector(s)",
                REGION: "Geographic Region(s) of Usage",
                COUNTRY: "Country/Countries of Usage",
                "COST MODEL": "Cost Model",
                "TYPE OF DATA COLLECTED": "Type of Data Collected",
                // Add more mappings as needed
              };
              return labelMap[category] || category;
            };

            return (
              <ModalSelect
                key={i}
                label={getLabel(tool?.category)}
                handleModal={() => setModal("start")}
                selected={
                  selection?.[tool?.category]
                    ? selection?.[tool?.category]
                        ?.toString()
                        ?.split(",")
                        ?.join(", ")
                    : null
                }
              />
            );
          })}
        </div>
        <div className="grid grid-cols-2 gap-6">
          {formInfo?.map((tool: any, i: number) => (
            <ToolsKPIsData
              key={i}
              start
              data={tool?.data}
              title={tool?.category}
              selection
              handleKpi={handleKpi}
              formIndex={i}
              shadow
              setInfo={() => setInfo(tool)}
              prevData={others?.kpiSelection || null}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ToolCategoryStep;
